// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navigation_navbar__YLVcJ","logo":"Navigation_logo__3ddgu","navlink":"Navigation_navlink__3wSTl","activenav":"Navigation_activenav__2G9SH"};